import React from "react";
import { graphql } from "gatsby";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";
import { SliceZone } from "@prismicio/react";
import Seo from "../components/Seo";

import Layout from "../components/Layout";
import { components } from "../slices";
const HomepageTemplate = ({ data }) => {
  // Handle missing data gracefully
  if (!data) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1>We make content that doesn&apos;t suck</h1>
        <p>Site is loading... (Prismic data not available)</p>
      </div>
    );
  }

  const homepage = data?.prismicHomepage || {};
  const topMenu = data?.prismicTopMenu || {};
  const footerData = data?.prismicFooter || {};

  return (
    <Layout topMenu={topMenu?.data || {}} footerData={footerData?.data || {}}>
      {homepage?.data?.body ? (
        <SliceZone slices={homepage.data.body} components={components} />
      ) : (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h1>We make content that doesn&apos;t suck</h1>
          <p>Content management system is being configured...</p>
        </div>
      )}
    </Layout>
  );
};

export const query = graphql`
  query homepageQuery($id: String!) {
    site {
      siteMetadata {
        title
        description
      }
    }
    prismicHomepage(id: { eq: $id }) {
      _previewable
      data {
        body {
          ... on PrismicSlice {
            id
            slice_type
            slice_label
          }
          ...HomepageDataBodyHero
          ...HomepageDataBodyIntro
          ...HomepageDataBodyBrands
          ...HomepageDataBodyFeaturedVideo
          ...HomepageDataBodyPress
          ...HomepageDataBodySocialVideos
          ...HomepageDataBodyPartners
          ...HomepageDataBodyEcommShowcase
          ...HomepageDataBodyRetail
          ...HomepageDataBodyCollabs
          ...HomepageDataBodyLicensed
          ...HomepageDataBodyAbout
          ...HomepageDataBodyStats
          ...HomepageDataBodyContact
        }
      }
    }
    prismicTopMenu {
      ...TopMenuFragment
    }
    prismicFooter {
      ...FooterFragment
    }
  }
`;

export const Head = () => (
  <>
    <Seo title="Doing Things | We make content that doesn't suck." />
    <link
      rel="preload"
      href="/images/hero-bg-v3.jpg"
      as="image"
      key="heroImage"
    />
  </>
);

export default withPrismicPreview(HomepageTemplate);
